import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n from '@/services/i18n/i18n';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';

export function WatcherLanguageFallbackFromDefault() {
  const { user_settings } = use_slice_user(['user_settings']);

  /*
   * EFFECTS
   */

  //fallback from default to i18n language
  use_effect(() => {
    if (user_settings.regional_language != CONSTANTS__shared.USER_DEFAULT_LANGUAGE) return; //language already established
    if (!CONSTANTS__shared.SUPPORTED_LANGUAGES.includes(i18n.language)) return; //this i18n language is not supported

    void FN_USER_SETTINGS__update(user_settings.clone({ regional_language: i18n.language }));
  }, [user_settings.regional_language, i18n.language]);

  /*
   * METHODS
   */

  return <></>;
}
